export interface ICompteMobileLight {
  readonly libelle: string;
  id: string;
  lastName?: string;
  firstName?: string;
}

export class CompteMobileLight implements ICompteMobileLight {
  constructor(
    public id: string,
    public lastName?: string,
    public firstName?: string
  ) {}

  static hydrate(obj: CompteMobileLight): CompteMobileLight {
    return new CompteMobileLight(obj.id, obj.lastName, obj.firstName);
  }

  public get libelle(): string {
    return [this.firstName, this.lastName].filter(s => !!s).join(' ');
  }
}
